import {reactive} from 'vue';
import {cartCount} from '../config';

export const cartStore = reactive({
    count: cartCount || 0,
});
